import { render, staticRenderFns } from "./News.vue?vue&type=template&id=65b9e6f1&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./News.vue?vue&type=style&index=1&id=65b9e6f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9e6f1",
  null
  
)

export default component.exports